import { render, staticRenderFns } from "./ModalSubscribeUserToReport.vue?vue&type=template&id=070889c2&scoped=true"
import script from "./ModalSubscribeUserToReport.vue?vue&type=script&lang=js"
export * from "./ModalSubscribeUserToReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070889c2",
  null
  
)

export default component.exports